import { useEffect, useState } from "react";



export default function Pagination({page, setPage, getList, nbpage}) {
    // states
    // const [nbpage, setNbpage] = useState(1);
    const [listpage, setListpage] = useState([]);

    const getPages = () => {
        let list = [...listpage];
        for (let i = 0; i < nbpage; i++) {
            list.push(i);
        }
        setListpage(list);
    }


    // comportements
    useEffect(() => {
        getPages();
    }, []);

    // affichage
    return (
        <>
            {nbpage > 1 && <div>
                <p className="mb-1">Pagination</p>
                <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <div className="btn-group me-2" role="group" aria-label="First group">
                        {
                            listpage.map((item, index) => (
                                <button key={index} type="button" 
                                    className={`btn ${page === index ? "btn-primary" : "btn-light"}`}
                                    onClick={() => {
                                            setPage(index)
                                            getList(index)
                                        }
                                    }
                                    disabled={page === index ? true : false}
                                    title={"valeur"+index}
                                >
                                    {index + 1}
                                </button>
                            ))
                        }

                    </div>

                </div>
            </div>}
        </>
    )
}